import {getUserCertificate, queryDefCode} from "@/api/projectManager_self";
import requests from "@/utils/requests_self";

class Service {
  static activityCode = 'gemstonesRecovery';

  static gemsInit = async () => {
    return await requests.get('/customer/recoveryActivity/v2/gemsInit');
  }

  static gemsRec = async ({ recId, count }) => {
    return await requests.post(
      '/customer/recoveryActivity/v2/gemsRec',
      JSON.stringify({ recId, count })
    );
  }

  static gemsRecLogs = async (recId, currentPage = 1, pageSize = 10) => {
    return await requests.get(
      `/customer/recoveryActivity/v2/gemsRecLogs/${recId}?currentPage=${currentPage}&pageSize=${pageSize}`
    );
  }

  static getActivityRules = async () => {
    return await queryDefCode({codeType: 'activityRule', code: Service.activityCode});
  }

  static getUserCertificateStatus = async () => {
    const res = await getUserCertificate({});
    if (res.code !== '000000') return {};
    return res.data || {};
  }

  /** realNameStatus: true 已实名 */
  static isUserVerified = (userInfo = {}) => {
    return userInfo?.realNameStatus === true || userInfo?.realNameStatus === 'true';
  }
}

export default Service;
